export default "__VITE_ASSET__AwX5Txa4__"